module.exports = __webpack_public_path__ + "static/media/icon_closeX_blk.685aa7b6.svg";